<template lang="pug">
  chapter-button(v-if="chapterButtons" type="previous" class="chapter-button" :disabled="previousChapterDisabled" :color="color" @click="dispatch" data-test="chapter-previous")
</template>

<script>
import { mapState } from 'redux-vuex';
import store from '@/store';

import select from '@/store/selectors';
import { PlayButton, ChapterButton, StepperButton } from '@/components/shared-components';
import { getForegroundColor } from '@/utils/color';

export default {
  components: {
    PlayButton,
    ChapterButton,
    StepperButton,
  },
  data: mapState({
    previousChapterDisabled: select.components.previousChapterDisabled,
    chapterButtons: select.components.chapterButtons,
    darkMode: select.customOptions.darkMode,
  }),
  methods: {
    dispatch: store.dispatch,
  },
  computed: {
    color() {
      return getForegroundColor(this.darkMode);
    },
  },
};
</script>
<style lang="postcss" scoped>
</style>
